import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

export const vendorBasePath = '/vendor-report';

const getVendorsReportRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.VENDOR_REPORT,
      route: vendorBasePath,
      title: ScreenNames.VENDOR_REPORT,
      icon: generateImage({
        noScale: true,
        name: 'attendance-log',
        alt: 'attendance-log',
        className: 'w-4 h-4',
      }),
      component: ComponentsMap.VENDOR_REPORT,
    },
  ];
};

export default getVendorsReportRoutes;
